










































































import {
  apiV1AdminAttachmentPath,
  apiV1AdminUserTopicPath,
  apiV1AdminUserTopicTopicCommentPath,
  apiV1AdminUserTopicTopicCommentsPath
} from '@/rails/routes'
import axios from 'axios'
import { Component, Emit, Prop } from 'vue-property-decorator'
import VueBase from '@/pages/vue-base'
import Topic, {ITopic} from '@/models/Topic'
import TopicComment, {ITopicComment} from '@/models/TopicComment'
import VueMarkdown from 'vue-markdown'
import {Attachment} from '@/models/Attachment'
import {saveAs} from 'file-saver'
import {KeyPair} from '@/types/KeyPair'

@Component(
  {
    components: {
      VueMarkdown
    }
  }
)
export default class TopicThread extends VueBase {
  showedEditThread = false
  showedEditComment = false
  @Prop(Object) readonly value!: Topic
  edit = new TopicComment({
    status: this.value.status || 'waiting'
  } as ITopicComment)
  editTopic = new Topic()
  editComment = new TopicComment()
  files: Array<File> = []
  statuses = [
    { text: '未着手', value: 'waiting' },
    { text: '処理中', value: 'in_progress' },
    { text: '処理済', value: 'done' },
    { text: '完了', value: 'completed' }
  ]

  @Emit()
  onSave(): void {}

  startEditThread(e: Event): void {
    this.editTopic = new Topic({
      title: this.value.title,
      description: this.value.description
    } as ITopic)
    this.showedEditThread = true
    e.preventDefault()
    e.stopPropagation()
  }

  startEditComment(comment: TopicComment): void {
    this.editComment = new TopicComment({
      id: comment.id,
      content: comment.content,
    } as ITopicComment)
    this.showedEditComment = true
  }

  async updateTopic(): Promise<void> {
    if(!this.editTopic.title || !this.editTopic.description) {
      this.showError('タイトル・内容を入力してください')
      return
    }
    try {
      await axios.put(apiV1AdminUserTopicPath(this.value.user_id, this.value.id), {
        topic: this.editTopic.toParams()
      })
      this.showMessage('変更を保存しました。')
      this.onSave()
      this.showedEditThread = false
    } catch (e) {
      console.log(e)
    }
  }

  async preSaveComment(): Promise<void> {
    if (!this.files.length &&
      !this.edit.content &&
      this.value.status === this.edit.status
    ) {
      this.showError('内容を入力してください')
      return
    }
    const loadedFiles = []
    if (this.files.length) {
      this.loadFile(this.files, async (file, e) => {
        loadedFiles.push({
          content_url: e.target.result,
          content_name: file.name
        })
        if (loadedFiles.length === this.files.length) {
          this.saveComment(loadedFiles)
        }
      })
    } else {
      this.saveComment([])
    }
  }

  async saveComment(loadedFiles: KeyPair): Promise<void> {
    try {
      await axios.post(apiV1AdminUserTopicTopicCommentsPath(this.value.user_id, this.value.id), {
        topic_comment: this.edit.toParams(),
        attachments: loadedFiles
      })
      this.showMessage('変更を保存しました。')
      this.onSave()
    } catch (e) {
      console.log(e)
    }
  }

  async updateComment(): Promise<void> {
    try {
      await axios.put(apiV1AdminUserTopicTopicCommentPath(this.value.user_id, this.value.id, this.editComment.id), {
        topic_comment: this.editComment.toParams(),
      })
      this.showMessage('変更を保存しました。')
      this.onSave()
    } catch (e) {
      console.log(e)
    }
  }

  loadFile(files: Array<File>, onLoad: (file: File, e: ProgressEvent<FileReader>) => void): void {
    if (files.length) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        const fileReader = new FileReader()
        fileReader.onload = (e): void => {
          onLoad(file, e)
        }
        fileReader.readAsDataURL(file)
      }
    }
  }

  async download(attachment: Attachment): Promise<void> {
    const res = await axios.get(apiV1AdminAttachmentPath(attachment.id), {
      responseType: 'blob'
    })
    const blob = new Blob([res.data], )
    saveAs(blob, attachment.name)
  }
}
